import { useEffect, useState } from "react";
import { ArrowLeft, CheckCircle2, LoaderCircle, XCircle } from "lucide-react";
import { camp } from "@/data/camp";

const backendUrl = process.env.REACT_APP_BACKEND_URL;

function PaymentShell({ children, tone = "dark", testId }) {
  return <main className={`payment-page payment-page-${tone}`} data-testid={testId}><div className="payment-page-grid" aria-hidden="true" /><div className="payment-card">{children}</div></main>;
}

export function PaymentSuccessPage() {
  const [state, setState] = useState({ status: "checking", payment_status: "pending" });
  const sessionId = new URLSearchParams(window.location.search).get("session_id");

  useEffect(() => {
    let active = true;
    let timer;
    let attempts = 0;
    const check = async () => {
      if (!sessionId) {
        setState({ status: "error", payment_status: "unknown" });
        return;
      }
      try {
        const response = await fetch(`${backendUrl}/api/payments/status/${encodeURIComponent(sessionId)}`, { credentials: "include" });
        const payload = await response.json();
        if (!response.ok) throw new Error(payload.detail || "Unable to confirm payment");
        if (!active) return;
        setState(payload);
        if (payload.payment_status !== "paid" && attempts < 20) {
          attempts += 1;
          timer = window.setTimeout(check, 2000);
        }
      } catch {
        if (active) setState({ status: "error", payment_status: "unknown" });
      }
    };
    check();
    return () => { active = false; window.clearTimeout(timer); };
  }, [sessionId]);

  const paid = state.payment_status === "paid";
  return <PaymentShell tone={paid ? "success" : "dark"} testId="payment-success-page"><div className="payment-icon">{paid ? <CheckCircle2 size={34} /> : state.status === "error" ? <XCircle size={34} /> : <LoaderCircle className="spin" size={34} />}</div><p className="section-kicker light-kicker" data-testid="payment-status">{paid ? "Registration confirmed" : state.status === "error" ? "Confirmation needs attention" : "Confirming your registration"}</p><h1 className="payment-title">{paid ? <>You are<br /><span>in.</span></> : state.status === "error" ? <>We could not<br /><span>confirm yet.</span></> : <>One moment.<br /><span>We are checking.</span></>}</h1>{paid ? <><p className="payment-message">Your {camp.eventName} registration payment has been confirmed. Keep this page for your next steps.</p><div className="payment-details"><strong>{camp.date}</strong><span>{camp.venue} / {camp.city}</span><span>Camper check-in begins at 9:00 AM</span></div><p className="payment-note">A confirmation email will be sent to the parent / guardian email used at checkout. Bring golf clubs and a positive attitude.</p></> : <p className="payment-message">{state.status === "error" ? "Your payment may still be processing. Please contact Top Tier Sports Camps if you do not receive confirmation shortly." : "Your payment is being verified securely. This page will update automatically."}</p>}<a className="payment-back-link" href="/" data-testid="payment-home-link"><ArrowLeft size={16} /> Back to Top Tier Sports Camps</a></PaymentShell>;
}

export function PaymentCancelPage() {
  return <PaymentShell tone="cancel"><div className="payment-icon"><XCircle size={34} /></div><p className="section-kicker light-kicker">Checkout canceled</p><h1 className="payment-title">Your spot<br /><span>is still open.</span></h1><p className="payment-message">No payment was completed. When you are ready, return to the camp page and start registration again.</p><a className="payment-back-link" href="/" data-testid="payment-cancel-home-link"><ArrowLeft size={16} /> Return to the camp page</a></PaymentShell>;
}
